import React, { useEffect } from "react"
import ReactSVG from "react-svg"
import ArrowLeft from "../../../images/go_back_icon_white.svg"
import { routerPaths } from "../../../v1/constants/paths"
import { Link } from "react-router-dom"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"

export const ServiceRequestLayout = ({ children }) => {
  let step = 0
  let name = ""
  let lastStepRoute = ""

  switch (window.location.hash) {
    case "#/service-request/add-vehicle?oil_change=true":
      step = 1
      name = "Add your Vehicle"
      lastStepRoute = routerPaths.addVehicle + "?oil_change=true"
      break
    case "#/service-request/add-vehicle":
      step = 1
      name = "Add your Vehicle"
      lastStepRoute = routerPaths.addVehicle
      break
    case "#/service-request":
      step = 1
      name = "Add your Vehicle"
      lastStepRoute = routerPaths.addVehicle
      break
    case "#/service-request/shop-selection":
      step = 2
      name = "Select a shop"
      lastStepRoute = routerPaths.addVehicle + "?oil_change=true"
      break
    case "#/service-request/appointment":
      step = 3
      name = "Select date & time"
      lastStepRoute = routerPaths.shopSelection
      break
    case "#/service-request/add-payment":
      step = 4
      name = "Add payment details"
      lastStepRoute = routerPaths.appointment
      break
    case "#/service-request/review-request":
      step = 5
      name = "Review appointment request"
      lastStepRoute = routerPaths.addPayment
      break
    default:
      step = 1
      name = "Add your Vehicle"
      lastStepRoute = routerPaths.addVehicle
      break
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      window.scrollTo(0, 0) // Fallback for other browsers
    }
  }, [step])

  return (
    <div className="service-request">
      <div className="service-request-header">
        <div className="header-content">
          {step == 1 ? (
            <span></span>
          ) : (
            <Link
              to={lastStepRoute}
              onClick={() =>
                trackFirebaseAnalytics({
                  event: gaJSON.EtoB_go_to_earlier_step,
                  params: {
                    currentStep: name,
                    prevStep: lastStepRoute
                  }
                })
              }
            >
              <ReactSVG src={ArrowLeft} />
            </Link>
          )}
          <div className="header-title">{"Service Request"}</div>
          <Link to={routerPaths.dashboard}>Cancel</Link>
        </div>
        <div className="service-request-stepper">
          <p className="bold">Step {step}/5 &nbsp;-&nbsp;</p>
          <p>{name}</p>
        </div>
      </div>
      <div className="service-request-content">{children}</div>
    </div>
  )
}
